function isColorType(color, keys) {
  return keys.every(key => color[key] != null);
}
export function isA98(color) {
  return isColorType(color, ["r", "g", "b", "a98"]);
}
export function isRGB(color) {
  return isColorType(color, ["r", "g", "b"]);
}
export function isHSL(color) {
  return isColorType(color, ["h", "s", "l"]);
}
export function isHWB(color) {
  return isColorType(color, ["h", "w", "b"]);
}
export function isLAB(color) {
  return isColorType(color, ["l", "a", "b"]);
}
export function isLCH(color) {
  return isColorType(color, ["l", "c", "h"]);
}
export function isOKLAB(color) {
  return isColorType(color, ["l", "a", "b", "ok"]);
}
export function isOKLCH(color) {
  return isColorType(color, ["l", "c", "h", "ok"]);
}
export function isCMYK(color) {
  return isColorType(color, ["c", "m", "y", "k"]);
}
export function isPercentage(value) {
  return value.indexOf("%") !== -1;
}
export function isGrad(value) {
  return value.indexOf("grad") !== -1;
}
export function isRad(value) {
  return value.indexOf("rad") !== -1;
}
export function isTurn(value) {
  return value.indexOf("turn") !== -1;
}